<template>
  <div class="login-qr-container">

    <verify-password-input @result="verifyPassword" v-if="!verified"></verify-password-input>

    <div class="notice" v-if="verified && loginQr">
      <p>
        QRコードを発行しました。<br>
        発行されたQRコードはこの画面を閉じると破棄されます。<br>ダウンロードまたは印刷をして保管してください。<br>また、印刷時は当ページのURLを隠すため印刷設定よりヘッダーとフッターを非表示にすることをおすすめします。</p>
    </div>

    <template v-if="isLoading">
      <loading :isLoading="isLoading" :message="'取得中...'"></loading>
    </template>

    <div class="qr" v-if="!isLoading && loginQr?.qrBase64">
      <p class="warning">このQRコードはログイン情報が含まれます。<br>他の人には絶対に見せないでください。</p>
      <div class="qr-info">
        <div class="text-info">
          <p><span>{{ loginQr.userName }}さん<br>のログインQRコード</span></p>
        </div>
        <img :src="loginQr.qrBase64" alt="" class="qr-image">
        <div class="text-info">
          <p><span>有効期限：</span>{{ loginQr.expires ? loginQr.expires : "期限なし"}}</p>
        </div>
      </div>

      <div class="qr-koyou">
        <div class="info" v-for="(info, index) in loginQr.koyouInfo" :key="index">
          <p><span>【{{ info.syuugyou_basyo_name }}（雇用契約ID: {{ info.koyou_keiyaku_id }}）での就業時間】</span></p>
          <template v-if="info.work_times === null || info.work_times.length < 1">
            <p>無し</p>
          </template>

          <template v-else>
            <div v-for="(item, index2) in info.work_times" :key="index2">
                <div class="item flex flex-align-center">
                    <p><span>
                        {{ getYoubiLabel(item).join('・') }}
                        <template v-if="item.weeks">/ 第{{ item.weeks.join('・') }}</template>
                        （半日勤務：
                        <template v-if="item.is_hannichi === false">無</template>
                        <template v-else-if="item.is_hannichi === true">有</template>
                        ）
                    </span></p>
                </div>
                <div class="item flex">
                    <p>
                        {{ timeToHHmm(item.start_time) }} 〜 {{ timeToHHmm(item.end_time) }}
                        （通常勤務時間 {{ timeToHHmm(item.tsuujou_times) }}／休憩 {{ timeToHHmm(item.kyuukei_times) }}）
                    </p>
                </div>
            </div>
          </template>
        </div>
      </div>

      <div class="qr-desc">
        <img :src="'/img/qr_desc.jpg'" alt=""/>
      </div>

      <div class="buttons">
        <button type="button" class="btn success download" @click="download()">QRコードをダウンロードする</button>
        <button type="button" class="btn success print" @click="window.print()">画面を印刷する</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useLoginQr } from '@/composable/qr/login-qr';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';
import { defineComponent, ref } from 'vue';
import { timeToHHmm } from '@/filters/common';
import VerifyPassword from "@/components/auth/VerifyPassword.vue"

export default defineComponent({
  props: {
    userId: {
      type: Number,
      require: true,
      default: null
    },
  },
  setup(props) {
    const { loginQr, getLoginQr, isLoading } = useLoginQr()
    const { getYoubiLabel } = useKoyouKeiyakuInit()

    let verified = ref(false);
    let password = ref('')
    let isVisible = ref(false)

    const verifyPassword =  async (result: boolean) => {
      verified.value = result
      if(verified.value){
        await get()
      }
    }

    const get = async () => {
      if (await getLoginQr(props.userId)) {
        password.value = ''
      }
    }

    const download = async () => {
      if (!loginQr.value) {
        return
      }
      const element = document.createElement('a');
      element.href = encodeURI(loginQr.value.qrBase64);
      element.download = 'login_qr_user_' + props.userId + '.png';
      element.target = '_blank';
      element.click();
    }

    return {
      verifyPassword,
      loginQr,
      isLoading,
      download,
      password,
      isVisible,
      window,
      verified,
      timeToHHmm,
      getYoubiLabel,
    }
  },
  components: {
    'verify-password-input': VerifyPassword
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/login-qr.scss';
</style>

<style lang="scss">
@include mq(print) {
  header,
  .contents>h2,
  .tabs {
    display: none;
  }
}
</style>
